import { render, staticRenderFns } from "./CaptionEditor.vue?vue&type=template&id=1ea487fc&scoped=true&"
import script from "./CaptionEditor.vue?vue&type=script&lang=js&"
export * from "./CaptionEditor.vue?vue&type=script&lang=js&"
import style0 from "./CaptionEditor.vue?vue&type=style&index=0&id=1ea487fc&lang=css&scoped=true&"
import style1 from "./CaptionEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea487fc",
  null
  
)

export default component.exports